const functions = {
    availableMethods() {
        return [
            'getAll'
        ];
    }
};

export default functions;
